module.exports = __webpack_public_path__ + "img/5b1be31f353c5dabafb4d54851b58493.png";